import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@material-ui/core'

import Icon from 'common/components/base/Icon'
import Typography from 'common/components/base/Typography'

import SetAside from 'common/assets/images/empty/set-aside.svg?react'

import useStyles from './useStyles'

const HandoverDialogFailed = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div className="flex h-full w-full">
      <div className="flex flex-col items-center justify-center bg-red-50 flex-1">
        <Icon
          name="close"
          fill="currentColor"
          color="#ffffff"
          className="w-48 h-48"
        />
        <Typography variant="header" align="center" color="white">
          {t('SET_ASIDE')}
        </Typography>
      </div>
      <div className="flex flex-col items-center justify-center p-3 flex-1">
        <Typography
          variant="headerRegular"
          transform="none"
          align="center"
          className="mt-8"
        >
          {t('ATTENTION_SET_ASIDE_MSG')}
        </Typography>
        <SetAside className="" />
      </div>
    </div>
  )
}

export default HandoverDialogFailed
